import {PersonFormDefaultValues, PersonFormProps, PersonFormRawValues, PersonFormType} from "./PersonForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {getObjectId, personType} from "@ots-frontend/ots-data";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import parsePhoneNumber from 'libphonenumber-js'

const getInitialValues = (defaultValues: PersonFormDefaultValues | undefined): PersonFormRawValues => {
  return {
    type: defaultValues?.type?.code,
    firstName: defaultValues?.firstName,
    lastName: defaultValues?.lastName,
    barcode: defaultValues?.barcode,
    company: getObjectId(defaultValues?.company),
    username: defaultValues?.username,
    password: undefined,
    passwordSet: defaultValues?.passwordSet,
    passwordChanged: false,
    emailAddress: defaultValues?.emailAddress,
    phoneNumber: defaultValues?.phoneNumber,
    preferredLanguage: defaultValues?.preferredLanguage?.code,
    doNotUse: defaultValues?.doNotUse,
  }
}

export type UsePersonFormProps = Pick<PersonFormProps, 'defaultValues'> & {}

export function usePersonForm(props: UsePersonFormProps): PersonFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])
  const {companyId} = useAuth()

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
      company: defaultValues?.company ?? companyId,
    }),
    validate: {
      type: (value) => value ? undefined : t("common.validation.required", "Required"),
      lastName: (value) => value ? undefined : t("common.validation.required", "Required"),
      firstName: (value) => value ? undefined : t("common.validation.required", "Required"),
      company: (value) => value ? undefined : t("common.validation.required", "Required"),
      emailAddress: (value) => !value ? undefined : (/^\S+@\S+$/.test(value) ? null : t("common.validation.email", "Invalid Email")),
      username: (value, values) => values.type === personType.user.code || values.type === personType.admin.code ? (value ? undefined : t("common.validation.required", "Required")) : undefined,
      password: (value, values) => {
        if (values.type !== personType.user.code && values.type !== personType.admin.code) {
          return undefined
        }

        return value || values.passwordSet ? undefined : t("common.validation.required", "Required")
      },
      phoneNumber: (value) => {
        if (!value) {
          return undefined
        }

        const phoneNumber = parsePhoneNumber(value, 'US')
        if (!phoneNumber) {
          return t("common.validation.phone", "Invalid Phone Number")
        }

        return phoneNumber.isValid() ? undefined : t("common.validation.phone", "Invalid Phone Number")
      },
    },
  })

  return form
}
